import { type EntityOptions, getNestedEntity } from 'models';
import { CompassLineIcon, Empty } from 'ui';
import { EntityList } from '../../components/entity-list';
import { useChannelEntitiesQuery } from '../../queries';
import type { ChannelEntityType } from '../../types';

type P = {
  channelId: string;
  getPathToEntityDetail: (id: string, options: EntityOptions) => string;
  subject?: ChannelEntityType;
};

const AllEntities = ({ channelId, getPathToEntityDetail, subject }: P) => {
  const {
    data: channelEntitiesData,
    fetchNextPage,
    hasNextPage,
    isFetching,
    isLoading,
  } = useChannelEntitiesQuery({
    channelId,
    pageSize: 12,
    subject,
  });

  const entities = channelEntitiesData?.pages.flat();

  return (
    <EntityList
      empty={
        <Empty
          description={{
            subtitle: 'There are no channels to display here',
            title: 'No channels',
          }}
          image={<CompassLineIcon />}
        />
      }
      entities={entities?.map((entity) => getNestedEntity(entity))}
      fetchNextPage={fetchNextPage}
      getPathToEntityDetail={getPathToEntityDetail}
      hasNextPage={hasNextPage}
      isFetching={isFetching}
      isLoading={isLoading}
    />
  );
};

export default AllEntities;
